import UserAppealsList from "../../components/appeals/UserAppealsList"

export const AppealsUsersPage = () => {

    return (
        <UserAppealsList></UserAppealsList>
    )
}